/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  registerSucceededNote: {
    id: "RegisterSucceededComponent.note",
    defaultMessage: "Info",
  },
  registerSucceededNoteText: {
    id: "RegisterSucceededComponent.noteText",
    defaultMessage: "We have sent you a link by email, your account will be activated after confirmation.",
  },
  registerSucceededHeading: {
    id: "RegisterSucceededComponent.registerSucceededHeading",
    defaultMessage: "Thank you for your registration",
  },
  resendSucceededHeading: {
    id: "RegisterSucceededComponent.resendSucceededHeading",
    defaultMessage: "Resend activation link successfully",
  },
  registerSucceededText: {
    id: "RegisterSucceededComponent.registerSucceededText",
    defaultMessage: "You will recieve an e-mail with an activation link. Please click it to activate your account.",
  },
  registerSucceededButton: {
    id: "RegisterSucceededComponent.registerSucceededButton",
    defaultMessage: "Go back to login",
  }
});

export default MESSAGES;